const isDev = import.meta.env.VITE_NODE_ENV === 'development';
// Environment configuration
export const env = {

  // API Configuration
  API_URL: isDev
    ? (import.meta.env.VITE_API_URL_DEV ?? 'http://localhost:3002/')
    : (import.meta.env.VITE_API_URL ?? 'https://kinerfy.fly.dev/'),
  API_KEY: import.meta.env.VITE_API_KEY || '',

  // App Configuration
  APP_NAME: import.meta.env.VITE_APP_NAME || 'Kinerfy',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',

  // Environment
  NODE_ENV: isDev ? 'development' : 'production',
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_PRODUCTION: import.meta.env.PROD,

  // Feature Flags
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  ENABLE_DEBUG: import.meta.env.VITE_ENABLE_DEBUG === 'true',
} as const

// Type for environment variables
export type Env = typeof env

// Helper function to validate required environment variables
export function validateEnv() {
  const requiredVars = [
    'VITE_API_URL',
    'VITE_API_KEY',
  ]

  const missingVars = requiredVars.filter(
    (varName) => !import.meta.env[varName as keyof ImportMetaEnv]
  )

  if (missingVars.length > 0) {
    console.warn(
      `Missing required environment variables: ${missingVars.join(', ')}`
    )
  }
} 